
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Home from './components/home/Home';
import AboutAndResume from './components/about/AboutAndResume';
import { IconCloudDemo } from './components/home/whatIDo/IconCloudDemo';
import Footer from './components/common/Footer';
import FullProjectDescription from './components/project/FullProjectDescription';
import ScrollToTop from './components/config/ScrollToTop';
import Contact from './components/contact/Contact';
import ChatWidget from './components/aiAgent/ChatWidget';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import BlogPage from './components/blogPage/BlogPage';
import { DsaTracker } from './components/DSATracker/DsaTracker';
// import { ThemeProvider } from '@material-tailwind/react';

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => setIsChatOpen(prev => !prev);
  const openChat = () => setIsChatOpen(prev => !prev);
  return (
    <div>
      {/* <ThemeProvider> */}
      <Router>
        <ScrollToTop />
        <Navbar/>
        {/* <Globe /> */}
        <Routes>
        
          {/* <Route path="/" element={<Home/>} /> */}
          <Route
            path="/"
            element={<Home openChat={openChat} />} // 
          />
          <Route path='/about' element={<AboutAndResume/>}/>
          <Route path='/demo' element={<IconCloudDemo/>}/>
          <Route path="/project-details" element={<FullProjectDescription />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/blog" element={<BlogPage/>} />
          <Route path="/dsaTracker" element={<DsaTracker/>} />
          {/* <Route path="/chatbot" element={<Chatbot />} /> */}
        </Routes>
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        <Footer/>
        <ChatWidget isOpen={isChatOpen} toggleChat={toggleChat} />
      </Router>
      {/* </ThemeProvider> */}
      
    </div>
  );
}

export default App;
